import { useFetchTracker } from '../../lib/fetches.ts';
import { DAYS_PLURALS, pluralize } from '../../lib/helpers.ts';
import Skeleton from '../Skeleton.tsx';
import DayProgressIndicator from './DayProgressIndicator.tsx';

export function Tracker() {
    const { data, isLoading } = useFetchTracker();

    const days = data?.days ?? [];

    const daysStreak = data?.daysStreak ?? 0;
    const daysStreakPlural = pluralize(daysStreak, DAYS_PLURALS);

    return (
        <div>
            <h4 className="mb-2">
                {!isLoading ? (
                    <span>
                        {daysStreak === 0
                            ? 'Začni dnes!'
                            : `${daysStreak} ${daysStreakPlural} v kuse!`}
                    </span>
                ) : (
                    <Skeleton count={1} className="h-6 w-40" />
                )}
            </h4>
            <div className="space-x-3">
                {days.map(({ day, done }, idx) => {
                    return (
                        <DayProgressIndicator
                            key={day}
                            day={new Date(day).getDay()}
                            status={done ? 'completed' : 'empty'}
                            isToday={idx === days.length - 1}
                        />
                    );
                })}
                {isLoading
                    ? Array.from({ length: 7 }).map((_, i) => (
                          <div
                              className="inline-flex flex-col items-center"
                              key={i}
                          >
                              <Skeleton className="mb-2 h-3 w-4" />
                              <Skeleton className="h-6 w-6 rounded-full" />
                          </div>
                      ))
                    : null}
            </div>
        </div>
    );
}
